import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { map, Observable } from 'rxjs';

import { DatepickerTheme } from '@fcom/service-forms/components/common/datepicker.component';
import { SelectOption } from '@fcom/common';
import { LanguageService } from '@fcom/ui-translate';
import { LocalDate } from '@fcom/core/utils';
import { PersonalDetailsForm } from '@fcom/common/interfaces/corporate/corporate.interface';

import { getPhonePrefixOptions } from '../../../utils/utils';

@Component({
  selector: 'fin-personal-details-form',
  templateUrl: './personal-details-form.component.html',
  styleUrls: ['./personal-details-form.component.scss'],
})
export class PersonalDetailsFormComponent implements OnInit {
  protected readonly DatepickerTheme = DatepickerTheme;
  protected readonly SvgLibraryIcon = SvgLibraryIcon;

  phonePrefixes$: Observable<SelectOption[]>;
  salutations$: Observable<SelectOption[]>;

  maxBirthDate = LocalDate.now().minusYears(13);
  minBirthDate = LocalDate.now().minusYears(100);

  @Input() formGroup: FormGroup<PersonalDetailsForm>;

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    const options = ['Mr', 'Mrs', 'Ms'];
    const keys = options.map((o) => `CORPORATE.corporatePortal.addUser.fields.salutations.${o}`);
    this.salutations$ = this.languageService.translateMultiple(keys).pipe(
      map((translations) =>
        options.map((o, i) => ({
          name: translations[i],
          value: `${o}.`,
        }))
      )
    );
    this.phonePrefixes$ = getPhonePrefixOptions(this.languageService.translate('countryCodes'));
  }
}
